import { useState} from "react";
import { useForm } from "react-hook-form";
import { CreateEmpresa } from "../../../types/empresa";
import { CircularProgress } from "@mui/joy";
import { SaveButton } from "../../UtilitiesComponents/SaveButton";
import { CancelButton } from "../../UtilitiesComponents/CancelButton";
import { useNavigate } from "react-router";
import { useCreateEmpresaMutation } from "../../../api/empresa/empresaApi";
import { getErrorMessage } from "../../../utils/errorHelpers";
import { ErrorMessage } from "../../UtilitiesComponents/ErrorMessage";
import { useGetFrecuenciaFilterDataQuery } from "../../../api/filter/dataFilterApi";
import { LoadingScreen } from "../../Utils/LoadingScreen";
import { ContactoSection } from "./ContactoSection";
import { UltimaVisitaSection } from "./UltimaVisitaSection";
import { DomicilioSection } from "./DomicilioSection";
import { DatosGeneralesSection } from "./DatosGeneralesSection";

export function CreateEmpresaForm() {
    const navigate = useNavigate();
    const [createEmpresa, { isLoading }] = useCreateEmpresaMutation();
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const {
        data: filters,
        isLoading: filterLoading,
        isSuccess: filterSuccess
    } = useGetFrecuenciaFilterDataQuery([]);

    const {
        register,
        handleSubmit,
        setValue,
        watch,
        formState: { errors },
    } = useForm<CreateEmpresa>();

    const submit = handleSubmit(async (data: CreateEmpresa) => {
        try {
            setErrorMessage(null);

            if(parseInt(data.tipoEmpresaId) === 1)
            {
                data.ultimaVisita = null;
            }

            const response = await createEmpresa(data).unwrap();
            
            navigate(`/empresa/${response.id}`);
            
        } catch (error) {
            setErrorMessage(getErrorMessage(error));
        }
    });

    const tipoEmpresa = parseInt(watch("tipoEmpresaId"));

    if(filterLoading || filterSuccess === false || filters === undefined)
        return (<LoadingScreen />);

    return (
        <div className="w-full h-full max-h-screen p-3 overflow-auto">

            <p className="font-semibold text-2xl mb-4">Registrar nueva empresa</p>

            <form onSubmit={submit} className="grid" autoComplete="off">

                <DatosGeneralesSection
                    register={register}
                    errors={errors}
                    selectValues={filters}
                    setValue={setValue} />

                <div className="border border-gray-500 my-8"></div>

                <DomicilioSection
                    register={register}
                    errors={errors}
                    selectValues={filters} />
                
                {tipoEmpresa == undefined || tipoEmpresa !== 1 && (
                <>
                <div className="border border-gray-500 my-8"></div>

                <UltimaVisitaSection 
                    register={register}
                    selectValues={filters}/>
                </>)}

                <div className="border border-gray-500 my-8"></div>

                <ContactoSection
                    register={register}
                    errors={errors} />

                {errorMessage && (
                    <div className="my-2">
                        <ErrorMessage
                            customMessage>
                            <p className="text-sm">{errorMessage}</p>
                        </ErrorMessage>
                    </div>
                )}

                <div className="flex gap-x-4 justify-center my-8">
                    {isLoading
                    ? 
                    <div className="w-[105px] h-[27px] flex items-center justify-center">
                        <CircularProgress sx={{
                            "--CircularProgress-progressThickness": "4px",
                            "--CircularProgress-trackThickness": "4px",
                            "--CircularProgress-size": "25px"
                        }}/>
                    </div>
                    : 
                    <>
                    <SaveButton
                        text="Guardar"
                        type="submit"/>
                    <CancelButton
                        onClick={()=> navigate(-1)}/>
                    </>}
                </div>

            </form>
        </div>
    );
}